export const downloadStaticFile = (path: string, notUseBaseUrl?: boolean) => {
	if (notUseBaseUrl) return path;
	return new URL(path, process.env.REACT_APP_STORAGE_BASE_URL).href;
};
